const firstTimeModalSuccess = {
  'first-time-modal-success-title': '¡Hecho!',
  'first-time-modal-success-message': 'Te has suscrito exitosamente a nuestro boletín. Por favor abre tu email y completa la verificaion para poder recibir nuestras novedades.',
  'first-time-modal-email-domain-not-fund': 'Servicio de correo no reconocido. Por favor abra su email manualmente.'
};

export default firstTimeModalSuccess;
